module.exports = __webpack_public_path__ + "img/7.770d22ed.png";